var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0654 5.69298V10.1335H15.4102V6.48488H30.2791V2.42615L40.101 10.2568L30.2791 18.0868V14.0401H28.9344V20.0453C28.9344 20.4277 29.3355 20.6478 29.6195 20.4211L41.7807 10.7258C42.0731 10.4925 42.0731 10.0199 41.7807 9.78659L29.6195 0.0913243C29.3355 -0.134762 28.9344 0.0847101 28.9344 0.467133V5.02735H14.6796C14.34 5.02735 14.0654 5.32499 14.0654 5.69298Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.219213 17.4035L12.381 7.70829C12.665 7.4816 13.0661 7.70167 13.0661 8.08409V12.6443H27.321C27.6599 12.6443 27.9351 12.9425 27.9351 13.3099V22.449C27.9351 22.8164 27.6599 23.1146 27.321 23.1146H13.0661V27.6628C13.0661 28.0452 12.665 28.2653 12.381 28.0386L0.219213 18.3434C-0.0731392 18.1107 -0.0731392 17.6368 0.219213 17.4041V17.4035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceIcon);
export default __webpack_public_path__ + "static/media/placeIcon.604e93cec6b1c8fcb45f091397fdb881.svg";
export { ForwardRef as ReactComponent };